class LazyScriptLoader {
  constructor() {
    this.scripts = [];
    this.selector = 'script[data-loading="lazy"][data-src]';
    this.interactionEvents = [
      "mouseover",
      "keydown",
      "touchmove",
      "touchstart",
      "click",
    ];
    this.loadAfterMsIfNoInteraction = 5000;
    this.loadTimer = null;
    this.boundStartLoadingScripts = this.startLoadingScripts.bind(this);
    this.hasLoaded = false;
  }

  init() {
    this.scripts = Array.from(document.querySelectorAll(this.selector));
    if (this.scripts.length === 0) return;

    this.interactionEvents.forEach((event) => {
      document.addEventListener(event, this.boundStartLoadingScripts, {
        passive: true,
      });
    });

    this.loadTimer = setTimeout(
      this.boundStartLoadingScripts,
      this.loadAfterMsIfNoInteraction
    );
  }

  startLoadingScripts() {
    if (this.hasLoaded) return;
    this.hasLoaded = true;

    clearTimeout(this.loadTimer);
    this.loadScripts();

    this.interactionEvents.forEach((event) => {
      document.removeEventListener(event, this.boundStartLoadingScripts);
    });
  }

  loadScripts() {
    this.scripts.forEach((script) => {
      if (script.dataset.loading === "loaded") return;
      this.loadScript(script);
    });
  }

  loadScript(script) {
    script.dataset.loading = "loaded";

    const newScript = document.createElement("script");
    newScript.src = script.dataset.src;
    newScript.async = true;
    if (script.defer) newScript.defer = true;

    // Copy type/module if needed
    if (script.type) newScript.type = script.type;
    if (script.dataset.callback) {
      newScript.onload = () => {
        const cbName = script.dataset.callback;
        if (typeof window[cbName] === "function") window[cbName]();
      };
    }

    script.replaceWith(newScript);
    console.log("[Lazy loaded script]:", newScript.src);
  }
}

const loader = new LazyScriptLoader();
window.addEventListener("load", () => loader.init());
